import Loader from "../classes/Loader";
import ImageGallery from "../classes/ImageGallery";
import Get from "../plugins/Get";
import Registry from "../plugins/Registry";

const STEPS = [
    'model',
    'modification',
    'complectation',
    // 'options',
    'design', //skip => only color prop;
    'final'
];


$(document).ready(function () {
    const conf = {};
    conf.url = '/buy/configurator/';
    conf.settings = window.conf_settings || {};
    conf.action = {};
    conf.activeStep = STEPS[0];
    conf.ajax = {};
    conf.btn = {};
    conf.btn.nextStep = '[step-next]';
    conf.container = $('[configurator]');
    conf.menu = {};
    conf.menu.container = $('.conf-menu');
    conf.menu.activeClass = 'active';
    conf.menu.disabledClass = 'disabled';
    conf.menu.items = $('.conf-menu__item');
    conf.menu.offsets = [];
    conf.stepContainer = conf.container.find('#step');
    conf.blockClass = 'configurator__item';
    conf.menuClass = 'configuration__menu';
    conf.menuItemClass = 'configuration__menu-item';
    conf.modelItem = '.card_configurator';
    if (!conf.container.length) return;

    /*
    settings structure:
            model_url|modification_id|complectation_id|(options_id // null|)design_id(color_id)|is_final_page
     */
    conf.action.parseSettings = () => {

        conf.settings = (typeof conf.settings === 'string') ? conf.settings.split('|') : {};
        conf.activeStep = STEPS[conf.settings.length];
        conf.settings = {
            'model_url': conf.settings[0],
            'modification_id': conf.settings[1],
            'complectation_id': conf.settings[2],
            // 'option_id': conf.settings[3], temporary removed
            'design_id': conf.settings[3],
            'is_final': conf.settings[4]
        };

    };
    conf.action.parseSettings();

    conf.action.loadNext = () => {
        let index = STEPS.indexOf(conf.activeStep);
        conf.action.load(STEPS[++index]);
    };

    conf.action.load = (step) => {
        if (!(~$.inArray(step, STEPS))) return;
        conf.activeStep = step;
        conf.action.updateMenu();
        conf.action.setData();
        conf.action.updateUrl();

        if (conf.ajax.hasOwnProperty('step')) conf.ajax.step.abort();

        conf.ajax.step = $.ajax({
            url: '/ajax/configurator/' + step + '/',
            type: 'JSON',
            method: 'POST',
            data: conf.settings,
            beforeSend: conf.beforeSend('#step'),
            success: (data) => {
                if (data.status === 'ok' && step === 'final') {
                    conf.action.render(data);
                    window.location.reload();
                }
                if (data.status === 'ok') conf.action.render(data);
                else conf.action.handleError(data);
            },
            error: (data) => {
                conf.action.handleError(data);
            },
            complete: conf.onComplete('#step', 'step'),
        });
    };

    conf.beforeSend = (selector) => {

        conf.inAction = true;
        Loader.instance(selector).start();

    };

    conf.onComplete = (selector, ajax = {}) => {

        Loader.instance(selector).destroy();
        if (ajax && conf.ajax.hasOwnProperty(ajax)) conf.ajax[ajax].abort();
        conf.inAction = false;

    };

    conf.action.render = (data) => {
        const html = data.response.html;
        conf.action.appendData(html);
        conf.action.animateData();
        conf.action.transformToActive();
    };

    conf.action.handleError = (data) => {
        if (typeof data.response === 'object') console.warn(data.response.message);
        else console.log(data);
    };

    conf.action.appendData = (html) => {
        const step = $('#step-' + conf.activeStep);
        if (step.length)
            step.replaceWith(html);
        else
            conf.stepContainer.append(html);
    };

    conf.action.animateData = () => {

        const gallery = $('.image-gallery');
        if (gallery.length) ImageGallery.init(gallery);
        const step = $('#step-' + conf.activeStep);
        setTimeout(() => {
            step.prev().addClass('configurator__item_removed');
            step.removeClass('configurator__item_removed');
            step.removeClass('configurator__item_hidden');
        }, 50);
        setTimeout(() => {
            step.prev().addClass('configurator__item_showing');
            step.removeClass('configurator__item_showing');
        }, 400);

    };

    conf.action.set = (name, value) => conf.settings[name] = value;

    conf.action.setData = () => {
        let i,
            input,
            inputType,
            activeBlock,
            block,
            val,
            blockName;
        const start = STEPS.indexOf(conf.activeStep);

        if (start > 1) {
            activeBlock = STEPS[start - 1];
            block = $('#step-' + activeBlock);
            blockName = activeBlock;

            if (block.length) {

                blockName = block.get(0).id.slice(5, block.get(0).id.length);
                inputType = block.find('[data-step]').data('step');


                input = block.find('[type="hidden"]');
                if (inputType) {
                    if (inputType === 'checkbox') {
                        input = block.find('[type="checkbox"][checked]');
                    }
                }
                val = input.val();

            } else val = conf.action.getValFromURL(activeBlock);
            if (typeof val === 'undefined') console.warn('Ошибка вычисления значения текущего блока');

            conf.action.set(blockName + '_id', val);
        }

        for (i = start; i < STEPS.length; i++) {
            conf.action.set(STEPS[i] + '_id', undefined);
        }

    };

    conf.action.getValFromURL = (block) => {

        let get,
            route,
            val;

        if (block === 'model') {
            route = window.location.pathname.slice(1, -1).split('/');
            val = route[2];
        } else {
            get = Get.parse(window.location.search);
            val = get[block + '_id'];
        }

        return val;

    };

    $(document).on('click', '.' + conf.menuItemClass, function (e) {

        let block;
        e.preventDefault();

        if ($(this).hasClass('active')) return;
        block = $(this).data('block');

        if (block === 'MODEL') conf.reset();
        conf.action.load(block);

    });

    $(document).on('click', conf.modelItem, function (e) {

        let model;
        e.preventDefault();
        if (conf.inAction) return;
        conf.inAction = true;
        model = $(this).data('model-url');
        conf.action.init(model);

    });

    conf.action.init = (model) => {
        conf.action.set('model_url', model);
        conf.action.load('modification');
    };

    conf.action.updateMenu = (reset = false) => {

        let element,
            i,
            finalMenu,
            removeClass,
            addClass;
        if (reset) conf.reset();

        conf.menu.items.removeClass(conf.menu.activeClass + ' ' + conf.menu.disabledClass);
        removeClass = conf.menu.activeClass + ' ' + conf.menu.disabledClass;
        addClass = '';

        finalMenu = $('[data-menu="final"]');

        for (i = 0; i < conf.menu.items.length; i++) {
            element = conf.menu.items.eq(i);
            if (element.data('menu') === conf.activeStep) {
                element.removeClass(removeClass).addClass(conf.menu.activeClass);
                removeClass = conf.menu.activeClass;
                addClass = conf.menu.disabledClass;
            } else {
                element.removeClass(removeClass).addClass(addClass);
            }
        }

        if (conf.activeStep === 'final') {
            finalMenu.removeClass('disabled_important');
        }
        else
            finalMenu.addClass('disabled_important');

        conf.menu.container.find('[data-menu="' + conf.activeStep + '"]').addClass(conf.menu.activeClass).next().addClass();

    };

    conf.action.backTo = (data) => {
        let step,
            remove = false;

        for (step of STEPS) {
            if (remove) $('#step-' + step).remove();
            if (step === data) remove = true;
        }

        Registry.forget('Popup', '#popup_complectation');
        conf.action.load(data);

    };

    conf.action.changeChoosen = (block, item) => {
        block.find('[type="checkbox"]').prop('checked', false).removeAttr('checked');
        item.find('[type="checkbox"]').prop('checked', true).attr('checked', 'checked');
    };

    conf.action.updateUrl = () => {
        let setting,
            update = true,
            get = '?',
            url = conf.url;

        if (typeof conf.settings.model_url !== 'undefined')
            url += conf.settings.model_url + '/';

        if (conf.activeStep !== 'model')
            url += conf.activeStep + '/';
        else
            url = conf.url;


        for (setting in conf.settings) {
            if (conf.settings.hasOwnProperty(setting) && setting !== 'model_url') {
                if (update) {
                    if (conf.activeStep.indexOf(setting) === 0) {
                        update = false;
                    } else {
                        if (typeof conf.settings[setting] !== 'undefined')
                            get += encodeURI(setting + '=' + conf.settings[setting] + '&');
                    }
                }
            }
        }

        if (get.length === 1) get = '';

        window.history.pushState(null, null, url + get);
    };

    conf.action.setOffsets = () => {
        conf.menu.items.map((index, item) => {
            conf.menu.offsets = [...conf.menu.offsets, $(item).offset().left];
        });
    };

    conf.action.transformToActive = (fast = false) => {

        const menuWidth = conf.menu.container.width(),
            transition = fast ? 0 : 300,
            activeIndex = STEPS.indexOf(conf.activeStep),
            offset = conf.menu.offsets[activeIndex],
            activeItemWidth = conf.menu.items.eq(activeIndex).width();

        conf.menu.container.animate({
            scrollLeft: offset - menuWidth / 2 + activeItemWidth / 2
        }, transition);

    };

    $(document).on('click', conf.btn.nextStep, function (e) {
        let block;
        if ($(e.target).attr('popup')) return;

        e.preventDefault();
        block = $(this).parents('.' + conf.blockClass);
        if (block.hasClass('conf-choose__list')) conf.action.changeChoosen(block, $(this));
        conf.action.loadNext();
    });

    if (conf.menu.items.length) {
        conf.menu.items.on('click', function (e) {
            e.preventDefault();

            // if (this.hasAttribute('model')) conf.action.updateMenu(true);
            conf.action.backTo(this.dataset.menu);

        });
    }

    conf.action.setOffsets();
    if ($(window).width() < 768) conf.action.transformToActive(true);

    $(document).on('change', '#complectation-difference', function () {
        const table = $(this).parents('.popup').find('table'),
            items = table.find('.noDifference');

        if ($(this).prop('checked'))
            items.hide();
        else
            items.show();
    });

    // const finalCheckboxSelector = '.configurator__final-checkbox';

    // $(document).on('click',finalCheckboxSelector, function () {
    //     const finalCheckbox = $(finalCheckboxSelector),
    //         active = finalCheckbox.filter(index => finalCheckbox.eq(index).prop('checked'));

    //     let sale = 0,
    //         price = $('[data-rrc]').data('rrc');

    //     active.each(function () {
    //         sale += $(this).data('sale');
    //     });

    //     price -= sale;

    //     $('[data-minprice] span').html($.number(price, 0, '', ' ') + ' <span class="ruble">₽</span>');
    //     $('[popup-model-price]').attr('popup-model-price', $.number(price, 0, '', ' '));

    // });

});


